export const en = {
    advisorNameSearchNoResultsPrefix: "Please try again or search by ",
    advisorNameSearchNoResultsLinkText: "advisor type",
    advisorsPlaceholder: "Enter Address or Zip Code",
    advisorSearchByName: "Search by Name",
    advisorSearchByType: "Search by Advisor Type",
    advisorSearchByTypeCTA: "Search",
    advisorSearchByTypeError: "Please enter a valid search location, or allow geolocation.",
    advisorSearchByNameError: "Please enter advisor name.",
    advisorSearchNamePlaceholder: "Advisor Name",
    advisorTypePlaceholder: "Advisor Type",
    ail: "AIL",
    applyNowCta: "Prequalify Online",
    atm: "ATM",
    backToResults: "Back to search results",
    branchInfo: "Branch Information",
    callHeadline: "Call",
    clientLoginCta: "Client Login",
    connectCta: "Connect on LinkedIn",
    directions: "Directions",
    distancePlaceholder: "Distance",
    distance: "mi",
    driveThru: "Drive-Thru",
    driveUpAtm: "Drive Up ATM",
    emailHeading: "Email",
    findMyLocation: "Find my location",
    finraDescriptor: "Check the background of this investment professional on FINRA's BrokerCheck:",
    fullService: "Full Service",
    hoursPlaceholder: "Hours",
    investmentServicesHeading: "Simmons Investment Services",
    instantIssueDebitCard: "Instant Issue Debit Card",
    languagesHeading: "Languages",
    loading: "Loading",
    lobby: "Lobby",
    locationsPlaceholder: "Search",
    nmls: "NMLS",
    noResults: "No results found, please search again.",
    notice: "Notice!",
    npn: "NPN",
    quickDeposit: "Quick Deposit ATM",
    safeDepositBoxes: "Safe Deposit Boxes",
    services: "Services: ",
    servicesPlaceholder: "Services",
    title: "Find a branch or ATM",
    visitHeading: "Visit",
    walkUpAtm: "Walk Up ATM",
	availability: "Availability",
};
